import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import BackNext from '../../Common/SubComponents/BackNext';
import ButtonInput from '../Helpers/Input/ButtonInputWithoutIcon';
import { Container, Form, Row, Col } from 'react-bootstrap';
import { SvgIcon } from '@mui/material';
import { CONNECTICUT, NEW_YORK, COLORADO } from '../../../Helpers/Constants/States';
import Download from '../icons/download.svg?react';
import Shield from '../icons/Shield.svg?react';
import Hand from '../icons/Hand.svg?react';
import Ruler from '../icons/ic_ruler.svg?react';
import GetStateListForAflac from '../Helpers/StateListForAflac';
import Age from '../../../Helpers/Dates/Age';
import { getBrochure } from "../Helpers/Brochures";
import './ImportantBenifits.scss';

export default function ImportantBenifits(props) {
    const states = GetStateListForAflac();
    const formMethods = useForm({
        mode: 'all',
        reValidateMode: 'all',
    });

    const handleBrochure = (isHSA, state) => {
        const brochure = getBrochure(isHSA, state);
        props.downloadPDF(brochure.option, brochure.filename);
    };

    const optionData = [];
    const sencondOptionData = [];
    if (props.basicInfo && props.basicInfo.state !== CONNECTICUT && props.basicInfo.state !== COLORADO) {
        optionData.push({ title: "Doctor's Visits", field: "doctorVisits", value: props.formState.doctorVisits });
    }
    if (props.basicInfo && props.basicInfo.state === CONNECTICUT) {
        optionData.push({ title: "Hospital Admissions", field: "hospitalAdmissions", value: props.formState.hospitalAdmissions });
    }
    if (props.basicInfo && props.basicInfo.state !== CONNECTICUT) {
        optionData.push({ title: "Lab Tests", field: "labTests", value: props.formState.labTests });
        optionData.push({ title: "Diagnostic Exams", field: "diagnosticExams", value: props.formState.diagnosticExams });
    }
    optionData.push({ title: "Ground Ambulance", field: "groundAmbulance", value: props.formState.groundAmbulance });
    optionData.push({ title: "Air Ambulance", field: "airAmbulance", value: props.formState.airAmbulance });
    sencondOptionData.push({ title: "Daily Inpatient Confinement", field: "dailyHospitalConfinement", value: props.formState.dailyHospitalConfinement });

    if (props.basicInfo && props.basicInfo.state !== NEW_YORK && props.basicInfo.state !== CONNECTICUT) {
        sencondOptionData.push({ title: "Hospital Admissions", field: "hospitalAdmissions", value: props.formState.hospitalAdmissions });
    }
    if (props.basicInfo && props.basicInfo.state !== CONNECTICUT) {
        sencondOptionData.push({ title: "Invasive Diagnostic Exams", field: "invasiveDiagnosticExams", value: props.formState.invasiveDiagnosticExams });
    }
    if (props.basicInfo && props.basicInfo.state !== CONNECTICUT) {
        sencondOptionData.push({ title: "Surgeries", field: "surgeries", value: props.formState.surgeries });
    }
    sencondOptionData.push({ title: "ICU Confinement", field: "icuConfinment", value: props.formState.icuConfinment });
    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
    };

    let stateName = "";
    if (props.basicInfo) { stateName = states.find(x => x.value === props.basicInfo.state); }
    const age = Age(props.basicInfo.birthdate);
    const getRiders = (option) => {
        let isTextVisible = false;
        option.map((item, index) => {
            if (item.value === true) {
                isTextVisible = true;
            }
        });
        return isTextVisible;
    };

    return (
        <div>
            <Container fluid className="background-container d-flex justify-content-center border-class">
                <FormProvider {...formMethods}>
                    <Form onSubmit={props.onNext}>
                        <Row className="justify-content-center mt-4">
                            <div className="text-center mb-2 pt-4"><SvgIcon component={Shield} className="small-icons" color="primary" fontSize="large" /></div>
                        </Row>
                        <Row className="justify-content-center">
                            <div className="text-center form-title">Which benefits are important to you?</div>
                        </Row>
                        <Row className={`justify-content-center mx-auto`} role="group" aria-labelledby="Finding the right carriers">
                            {optionData.map((d, index) =>
                                <Col xs={6} lg="auto" sm="auto" md="auto" xl="auto" key={index} className="d-flex justify-content-center btn-wrapper">
                                    <ButtonInput title={d.title} subtitle={d.subtitle} value={d.value} onClick={() => handleValueChange(d.field, !d.value)} mobileWide={true} />
                                </Col>
                            )}
                        </Row>
                        <Row className={`justify-content-center mx-auto`} role="group" aria-labelledby="Finding the right carriers">
                            {sencondOptionData.map((d, index) =>
                                <Col xs={6} lg="auto" sm="auto" md="auto" xl="auto" key={index} className="d-flex justify-content-center btn-wrapper">
                                    <ButtonInput title={d.title} subtitle={d.subtitle} value={d.value} onClick={() => handleValueChange(d.field, !d.value)} mobileWide={true} />
                                </Col>
                            )}
                        </Row>
                        <div className='backnext-wrapper'>
                            <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} />
                        </div>
                    </Form>
                </FormProvider>
            </Container>
            <Container className="px-0">
                <Row className={`mb-2 download-brochure`}>
                    <Col md={4} className="d-flex align-items-center brochure-link" onClick={() => handleBrochure(false, props.basicInfo.state)}>
                        <SvgIcon component={Download} className="small-icons" color="primary" fontSize="large" />
                        <div className=" ms-2">
                            <span className='fw-bold primary-text'>Aflac Choice Brochure</span><br />
                            <span>Aflac Choice Brochure and Summary of Coverage (Outline of Coverage)</span>
                        </div>
                    </Col>
                </Row>

                <Row className="important-benifits text-center">
                    <Col md={4}>
                        <div className='details'>
                            <SvgIcon component={Ruler} color="primary" className="small-icons" fontSize="large" />
                            <h6 className='primary-text' >Primary Applicant</h6>
                            <h6><b>{props.basicInfo.gender === "M" ? "Male" : "Female"}</b></h6>
                            <h6><b>{age} yrs</b></h6>
                            <h6><b>{stateName !== "" ? stateName.label : ""}</b></h6>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className='details'>
                            <SvgIcon component={Hand} color="primary" className="small-icons" fontSize="large" />
                            <h6 className='primary-text'>HSA Coverage</h6>
                            <h6><b>No existing HSA</b></h6>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="details-last">
                            <SvgIcon component={Shield} color="primary" className="small-icons" fontSize="large" />
                            <h6 className='primary-text'>Optional Riders</h6>
                            {props.basicInfo.state !== CONNECTICUT && getRiders(optionData) && <h6><b>Extended Benefits Rider</b></h6>}
                            {props.basicInfo.state !== CONNECTICUT && getRiders(sencondOptionData) && <h6><b>Hospital Stay and Surgical Care Rider</b></h6>}
                            {props.basicInfo.state === CONNECTICUT && (getRiders(optionData) || getRiders(sencondOptionData)) && <h6><b>Hospital Stay Rider</b></h6>}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>

    );
}

ImportantBenifits.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

ImportantBenifits.DefaultFormState = (prefill = false, existingBasicInfo = null) => {
    return {
        groundAmbulance: prefill ? false : (existingBasicInfo && existingBasicInfo.groundAmbulance) || false,
        airAmbulance: prefill ? false : (existingBasicInfo && existingBasicInfo.airAmbulance) || false,
        icuConfinment: prefill ? false : (existingBasicInfo && existingBasicInfo.icuConfinment) || false,
        dailyHospitalConfinement: prefill ? false : (existingBasicInfo && existingBasicInfo.dailyHospitalConfinement) || false,
        doctorVisits: prefill ? false : (existingBasicInfo && existingBasicInfo.doctorVisits) || false,
        labTests: prefill ? false : (existingBasicInfo && existingBasicInfo.labTests) || false,
        diagnosticExams: prefill ? false : (existingBasicInfo && existingBasicInfo.diagnosticExams) || false,
        surgeries: prefill ? false : (existingBasicInfo && existingBasicInfo.surgeries) || false,
        invasiveDiagnosticExams: prefill ? false : (existingBasicInfo && existingBasicInfo.invasiveDiagnosticExams) || false,
        secondSurgicalOpinion: prefill ? false : (existingBasicInfo && existingBasicInfo.secondSurgicalOpinion) || false,
        hospitalAdmissions: prefill ? false : (existingBasicInfo && existingBasicInfo.hospitalAdmissions) || false,
    };
};
